import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductoRoutingModule } from './producto-routing.module';
import { ProductoComponent } from './producto.component';
import {UiModule} from '../../ui/ui.module';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatListModule} from '@angular/material/list';
import { ProductosListComponent } from './productos-list/productos-list.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import { ProductosNovedadesComponent } from './productos-novedades/productos-novedades.component';
import { ProductosOfertasComponent } from './productos-ofertas/productos-ofertas.component';
import { ProductosPoliticaVentaComponent } from './productos-politica-venta/productos-politica-venta.component';
import { MenuCategoriaComponent } from './menu-categoria/menu-categoria.component';
import { MarcasComponent } from './marcas/marcas.component';
import { ProductosChipsComponent } from './productos-chips/productos-chips.component';


@NgModule({
  declarations: [ProductoComponent, ProductosListComponent, BreadcrumbComponent, ProductosNovedadesComponent, ProductosOfertasComponent, ProductosPoliticaVentaComponent, MenuCategoriaComponent, MarcasComponent, ProductosChipsComponent],
  imports: [
    CommonModule,
    ProductoRoutingModule,
    UiModule,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatListModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule
  ]
})
export class ProductoModule { }
